import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { InspectionSectionService } from '../../services/index';
import { InspectionPoint, InspectionSection } from '../../models/index';
import { BaseModalPageComponent } from '../../../base-modal.component';

import * as _ from 'lodash';

@Component({
    templateUrl: './model-points.component.html',
    standalone: false
})
export class ImportPointsModelPointsPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  sectionId: string;
  folderId: string;
  targetInspectionId: string;
  targetSectionId: string;
  selectedPoints: InspectionPoint[] = [];
  points: InspectionPoint[];
  section: InspectionSection;
  errorMessage: string;
  createProcessing = false;
  navigationRoute: string;
  public loading: Boolean = true;

  constructor(
    public sectionService: InspectionSectionService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    location: Location,
    public cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.navigationRoute = this.router.url.includes('inspections') ? this.inspectionsRoute : this.templatesRoute;
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['targetId'];
      if (id == null) this.router.navigate([this.navigationRoute]);

      this.inspectionId = id;

      const sectionId = params['sectionId'];
      if (sectionId == null) this.router.navigate([this.navigationRoute, this.inspectionId]);

      this.sectionId = sectionId;

      this.folderId = params['folderId'];

      const targetInspectionId = params['modelId'];
      if (targetInspectionId == null) this.router.navigate([this.navigationRoute, this.inspectionId]);

      this.targetInspectionId = targetInspectionId;

      const targetSectionId = params['modelSectionId'];
      if (targetSectionId == null) this.router.navigate([this.navigationRoute, this.inspectionId]);

      this.targetSectionId = targetSectionId;

      this.initData();
    });
  }

  selectInspectionPoint(inspectionPoint: any): void {
    inspectionPoint.selected = !inspectionPoint.selected;
    if (inspectionPoint.selected) {
      this.selectedPoints.push(inspectionPoint);
    } else {
      this.selectedPoints = this.selectedPoints.filter((p) => p.id !== inspectionPoint.id);
    }
  }

  addPoints(): void {
    this.createProcessing = true;
    this.sectionService
      .addPoints(
        this.inspectionId,
        this.sectionId,
        this.targetInspectionId,
        _.map(this.selectedPoints, (el: any) => el.id),
        this.folderId
      )
      .subscribe((data) => {
        this.resetSelectedPoints();
        window.history.go(-3);
      });
  }

  cancel() {
    this.resetSelectedPoints();
    this.goToBack();
  }

  initData(): void {
    this.sectionService.getSection(this.targetInspectionId, this.targetSectionId).subscribe((section) => {
      this.section = section;
      this.points = section.points;
      this.cdRef.detectChanges();
      this.loading = false;
    });
  }

  resetSelectedPoints() {
    _.forEach(this.points, (p) => {
      p.selected = false;
    });
  }
}
